import * as planningApi from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./userLeaves.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getUserLeaves(action: actions.GetUserLeavesAction): SagaIterator {
  try {
    const { uid, year } = action.payload.params
    const unavailabilities = yield call(planningApi.getUserAbsences, {
      uid,
      year,
      leaves: true,
    })
    yield put(actions.getUserLeavesSuccess(unavailabilities && unavailabilities.data))
  } catch (e) {
    yield put(actions.getUserLeavesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* userLeavesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getUserLeaves)
}
